import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage";

import brandsReducer from "./slices/brandsSlice";
import categoriesReducer from "./slices/categoriesSlice.js";
import productsReducer from "./slices/productsSlice";
import ordersReducer from "./slices/ordersSlice";
import usersReducer from "./slices/usersSlice";
import cartReducer from "./slices/cartSlice";
import clientsReducer from "./slices/clientsSlice";
import myAccountReducer from "./slices/myAccountSlice";

import { combineReducers } from "redux";

const rootReducer = combineReducers({
  Brand: brandsReducer,
  Category: categoriesReducer,
  Product: productsReducer,
  Order: ordersReducer,
  User: usersReducer,
  Cart: cartReducer,
  Client: clientsReducer,
  MyAccount: myAccountReducer,
});

/* Sanea el slice User al rehidratar: si algún valor quedó persistido como
   null (p.ej. configsAdmin cuando /configs/:id no encuentra fila), se
   restaura con su valor por defecto para evitar crashes al renderizar. */
const sanitizeUserOnRehydrate = createTransform(
  (inbound) => inbound,
  (outbound) => {
    if (!outbound || typeof outbound !== "object") return {};
    return {
      ...outbound,
      configsAdmin: outbound.configsAdmin ?? {},
      userDetail: outbound.userDetail ?? {},
      allUsers: Array.isArray(outbound.allUsers) ? outbound.allUsers : [],
    };
  },
  { whitelist: ["User"] }
);

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["User", "Cart"], // solo lo importante
  transforms: [sanitizeUserOnRehydrate],
};

const persistedReducer = persistReducer(
  persistConfig,
  rootReducer
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

